module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('header', {
    staticClass: "col-xs-12 npd podcast__header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("REFLEXIONES")]), _vm._v(" "), (_vm.loaded_categorias == 'true') ? _c('ul', {
    staticClass: "col-xs-12 filtro"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'archive_reflexiones'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tTodos\n\t\t\t\t\t\t")])], 1), _vm._v(" "), _vm._l((_vm.categorias), function(categoria) {
    return _c('li', {
      staticClass: "nonactive",
      attrs: {
        "elpodcast": categoria.slug
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'interna_reflexion',
          params: {
            name: categoria.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(categoria.name) + "\n\t\t\t\t\t\t")])], 1)
  })], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 block npd "
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.loaded_categorias === 'true') ? _c('div', _vm._l((_vm.categorias), function(categoria) {
    return _c('div', {
      staticClass: "col-xs-12 col-xs-6 progitem progitem--podcast"
    }, [_c('div', {
      staticClass: "col-xs-12 npd progitem__wrap paused"
    }, [_c('div', {
      staticClass: "progitem__titulo"
    }, [_c('h3', [_vm._v(_vm._s(categoria.name))]), _vm._v(" "), _c('router-link', {
      staticClass: "todo",
      attrs: {
        "to": {
          name: 'interna_reflexion',
          params: {
            name: categoria.slug
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tver todo\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('router-link', {
      staticClass: "toint",
      attrs: {
        "to": {
          name: 'interna_reflexion',
          params: {
            name: categoria.slug
          }
        }
      }
    }, [_c('figure', [(categoria.categoria_meta.icono.sizes.hasOwnProperty('medium_large')) ? _c('img', {
      attrs: {
        "src": categoria.categoria_meta.icono.sizes['medium_large']
      }
    }) : _c('img', {
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/imgplay.jpg'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-centermid progitem__des"
    })])])], 1)])
  })) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a80bf8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archive_reflexiones.vue
// module id = 135
// module chunks = 0